import type { PatientModel } from '@ctw/shared/api/fhir/models/patient';
import { ProcedureModel } from '@ctw/shared/api/fhir/models/procedure';
import { SYSTEM_SUMMARY } from '@ctw/shared/api/fhir/system-urls';
import { MAX_OBJECTS_PER_REQUEST } from '@ctw/shared/api/fqs/client';
import { fqsRequestAll } from '@ctw/shared/api/fqs/client';
import {
  type ProcedureGraphqlResponse,
  procedureQuery,
} from '@ctw/shared/api/fqs/queries/procedures';
import type { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import type { GraphQLClient } from 'graphql-request';

export async function fetchProceduresById(
  telemetry: ReturnType<typeof useTelemetry>,
  graphqlClient: GraphQLClient,
  patient: PatientModel,
  ids: Array<string>,
) {
  const { data } = await fqsRequestAll<ProcedureGraphqlResponse>(
    telemetry,
    graphqlClient,
    procedureQuery,
    'ProcedureConnection',
    {
      upid: patient.UPID,
      cursor: '',
      first: MAX_OBJECTS_PER_REQUEST,
      filter: {
        ids: {
          anymatch: ids,
        },
        tag: { nonematch: [SYSTEM_SUMMARY] },
      },
    },
  );

  return data.ProcedureConnection.edges.map(
    ({ node }) => new ProcedureModel(node, node.ProvenanceList),
  );
}
